module.exports = __webpack_public_path__ + "static/img/back1.af7962ad.jpg";